import { FiSearch } from "react-icons/fi";
import styled from "styled-components";

export const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
  width: 100%;
  padding-top: 4rem;
`;

export const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

export const PageTitle = styled.h1`
  color: #ff6b35;
  line-height: 3rem;
  font-size: 3rem;
  margin-bottom: 1rem;
  font-weight: bold;
  background: linear-gradient(135deg, #ff6b35, #ff8c42);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const PageSubtitle = styled.p`
  color: #cccccc;
  font-size: 1.2rem;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
`;

export const ControlsSection = styled.div`
  background: #1a1a1a;
  border-radius: 15px;
  padding: 1.5rem;
  margin-bottom: 3rem;
  border: 1px solid #333;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const SearchWrap = styled.div`
  position: relative;
  flex: 1;
  max-width: 400px;
`;

export const SearchInput = styled.input`
  background: #2c2c2c;
  color: #fff;
  border: 1px solid #333;
  border-radius: 8px;
  padding: 0.8rem 2.5rem 0.8rem 1rem;
  width: 100%;
  font-size: 1rem;

  &::placeholder {
    color: #aaa;
  }

  &:focus {
    outline: none;
    border-color: #ff6b35;
  }
`;

export const SearchIcon = styled(FiSearch)`
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #ff6b35;
`;

export const FilterTabs = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

export const FilterTab = styled.button`
  background: ${({ $active }) => ($active ? "#ff6b35" : "#2c2c2c")};
  color: ${({ $active }) => ($active ? "#ffffff" : "#cccccc")};
  border: 1px solid ${({ $active }) => ($active ? "#ff6b35" : "#333")};
  padding: 0.6rem 1.2rem;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: ${({ $active }) => ($active ? "bold" : "normal")};
  font-size: 0.9rem;

  &:hover {
    background: #ff6b35;
    color: #ffffff;
    border-color: #ff6b35;
  }
`;

export const BandsGrid = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;

  flex-wrap: wrap;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    justify-content: center;
  }
`;

export const BandCard = styled.div`
  background: linear-gradient(135deg, #2c2c2c 0%, #1a1a1a 100%);
  border-radius: 15px;
  overflow: hidden;
  border: 1px solid #333;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  break-inside: avoid;
  page-break-inside: avoid;

  display: block;
  max-width: 430px;
  width: 100%;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 30px rgba(255, 107, 53, 0.1);
    /* border-color: #ff6b35; */
  }
`;

export const BandImage = styled.div`
  height: 300px;
  background: linear-gradient(45deg, #333, #555, #ff6b35);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  /* Image styles */
  .band-main-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }

  /* Overlay gradient */
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      rgba(255, 107, 53, 0.3),
      rgba(0, 0, 0, 0.6)
    );
    z-index: 2;
  }

  /* Band logo (fallback text) */
  .band-logo {
    position: absolute;
    z-index: 3;
    color: #ffffff;
    font-size: 2rem;
    font-weight: bold;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
    text-align: center;
    padding: 0 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  /* Overlay content container */
  .band-image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 15px;
  }
`;

export const GenreTag = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  background: ${({ genre }) =>
    genre === "rock"
      ? "#e74c3c"
      : genre === "punk"
      ? "#9b59b6"
      : genre === "rap"
      ? "#f39c12"
      : genre === "metal"
      ? "#34495e"
      : genre === "folk"
      ? "#27ae60"
      : "#ff6b35"};
  color: #ffffff;
  padding: 0.4rem 0.8rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: bold;
  z-index: 3;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

export const ProductCount = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  background: rgba(255, 107, 53, 0.95);
  color: #ffffff;
  padding: 0.4rem 0.8rem;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: bold;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: 0.3rem;
`;

export const BandContent = styled.div`
  padding: 2rem;
`;

export const BandHeader = styled.div`
  margin-bottom: 1.5rem;
`;

export const BandName = styled.h2`
  color: #ffffff;
  font-size: 1.6rem;
  margin-bottom: 0.5rem;
  font-weight: bold;
  line-height: 1.2;
`;

export const BandInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.8rem;
  margin-bottom: 1.5rem;
`;

export const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #cccccc;
  font-size: 0.9rem;

  svg {
    color: #ff6b35;
    flex-shrink: 0;
  }

  .label {
    font-weight: bold;
    color: #ff6b35;
  }
`;

export const BandDescription = styled.p`
  color: #cccccc;
  font-size: 0.95rem;
  line-height: 1.5;
  margin-bottom: 1.5rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const MembersSection = styled.div`
  margin-bottom: 1.5rem;
  min-height: 151px;
`;

export const MembersTitle = styled.h4`
  color: #ff6b35;
  font-size: 1rem;
  margin-bottom: 0.8rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const MembersList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const MemberTag = styled.span`
  background: #333;
  color: #cccccc;
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.8rem;
  border: 1px solid #444;
`;

export const AlbumsSection = styled.div`
  margin-bottom: 1.5rem;
`;

export const AlbumsTitle = styled.h4`
  color: #ff6b35;
  font-size: 1rem;
  margin-bottom: 0.8rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const AlbumsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
`;

export const AlbumItem = styled.div`
  color: #cccccc;
  font-size: 0.85rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.2rem 0;

  .album-name {
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    width: 320px;
  }

  .album-year {
    color: #ff6b35;
    font-weight: bold;
  }
`;

export const BandFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1.5rem;
  border-top: 1px solid #333;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const SocialBtn = styled.span`
  background: #333;
  color: #cccccc;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background: #ff6b35;
    color: #ffffff;
    transform: translateY(-2px);
  }
`;

export const BandActions = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const ActionBtn = styled.button`
  background: ${({ $primary }) => ($primary ? "#ff6b35" : "transparent")};
  color: ${({ $primary }) => ($primary ? "#ffffff" : "#ff6b35")};
  border: 2px solid #ff6b35;
  padding: 0.6rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-weight: bold;
  font-size: 0.9rem;

  &:hover {
    background: #ff6b35;
    color: #ffffff;
    transform: translateY(-1px);
  }
`;

export const NoResults = styled.div`
  text-align: center;
  padding: 4rem 2rem;
  color: #cccccc;

  margin-bottom: 2rem;

  h3 {
    color: #ff6b35;
    margin-bottom: 1rem;
    font-size: 1.5rem;
  }

  p {
    font-size: 1.1rem;
  }
`;

export const StatsSection = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
`;

export const StatCard = styled.div`
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 15px;
  padding: 1.5rem;
  text-align: center;
  transition: all 0.3s ease;

  &:hover {
    border-color: #ff6b35;
    transform: translateY(-2px);
  }
`;

export const StatNumber = styled.div`
  color: #ff6b35;
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

export const StatLabel = styled.div`
  color: #cccccc;
  font-size: 0.9rem;
`;

export const LoadMoreContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin-top: 3rem;
  padding: 2rem;
`;

export const LoadMoreButton = styled.button`
  background: linear-gradient(135deg, #ff6b35, #ff8c42);
  color: #ffffff;
  border: none;
  border-radius: 12px;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 4px 15px rgba(255, 107, 53, 0.3);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 25px rgba(255, 107, 53, 0.4);
    background: linear-gradient(135deg, #e55a2b, #ff6b35);
  }

  &:active {
    transform: translateY(-1px);
  }

  svg {
    font-size: 1.2rem;
  }
`;

export const LoadMoreText = styled.p`
  color: #cccccc;
  font-size: 0.9rem;
  text-align: center;
  margin: 0;
`;

// Pagination Components
export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin-top: 2rem;
  flex-wrap: wrap;
`;

export const PageBtn = styled.button`
  background: ${({ $active }) => ($active ? "#ff6b35" : "#2c2c2c")};
  color: #ffffff;
  border: 1px solid ${({ $active }) => ($active ? "#ff6b35" : "#333")};
  padding: 0.8rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  min-width: 44px;
  text-align: center;
  font-weight: ${({ $active }) => ($active ? "bold" : "normal")};
  transition: all 0.3s ease;

  &:hover {
    background: #ff6b35;
    border-color: #ff6b35;
    color: #ffffff;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

export const NavBtn = styled.button`
  background: #2c2c2c;
  color: #ffffff;
  border: 1px solid #333;
  padding: 0.8rem 1.2rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background: #ff6b35;
    border-color: #ff6b35;
    color: #ffffff;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

export const Ellipsis = styled.span`
  color: #999;
  padding: 0.8rem 0.3rem;
  font-size: 1.2rem;
  font-weight: bold;
  user-select: none;
`;
